/* Staroled theme - minimal vanilla JS, no dependencies.
   Handles: variant swatches, gallery, quantity, sticky add-to-cart. */
(function () {
  'use strict';

  var money = function (cents, format) {
    var amount = (cents / 100).toFixed(2);
    // Shopify's money_format is applied server-side for the initial render;
    // for JS updates we reuse the currency symbol captured from that render.
    return (format || '$') + amount;
  };

  /* ---------------- Buy box ---------------- */
  function initBuyBox(root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var symbol = root.getAttribute('data-currency-symbol') || '$';
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-option-value]'));
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var priceSave = root.querySelector('[data-price-save]');
    var chosenLabel = root.querySelector('[data-chosen-option]');
    var submit = root.querySelector('[data-atc]');
    var mainImg = root.querySelector('[data-gallery-main]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyThumb = document.querySelector('[data-sticky-thumb]');

    function findVariant(value) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].option === value) return variants[i];
      }
      return null;
    }

    function select(value, isInitial) {
      var v = findVariant(value);
      if (!v) return;

      swatches.forEach(function (s) {
        s.setAttribute('aria-checked', String(s.getAttribute('data-option-value') === value));
      });

      if (idInput) idInput.value = v.id;
      if (chosenLabel) chosenLabel.textContent = v.option;

      if (priceNow) priceNow.textContent = money(v.price, symbol);
      if (priceWas) {
        if (v.compare && v.compare > v.price) {
          priceWas.textContent = money(v.compare, symbol);
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
      }
      if (priceSave) {
        if (v.compare && v.compare > v.price) {
          priceSave.textContent = 'SAVE ' + Math.round((1 - v.price / v.compare) * 100) + '%';
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }

      if (stickyPrice) {
        stickyPrice.innerHTML = money(v.price, symbol) +
          (v.compare && v.compare > v.price ? ' <s>' + money(v.compare, symbol) + '</s>' : '');
      }

      // On first load keep the product's featured photo as the lead image;
      // only swap to the colour's photo once the shopper actually picks one.
      if (v.image && !isInitial) {
        if (mainImg) {
          mainImg.src = v.image;
          mainImg.alt = v.option;
        }
        if (stickyThumb) stickyThumb.src = v.image;
        syncThumbs(v.image);
      }

      if (submit) {
        if (v.available) {
          submit.disabled = false;
          submit.textContent = submit.getAttribute('data-text-available') || 'Add to cart';
        } else {
          submit.disabled = true;
          submit.textContent = submit.getAttribute('data-text-soldout') || 'Sold out';
        }
      }
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        select(s.getAttribute('data-option-value'));
      });
    });

    /* Gallery thumbs */
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    function syncThumbs(src) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.getAttribute('data-thumb') === src));
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-thumb');
        if (mainImg) mainImg.src = src;
        syncThumbs(src);
      });
    });

    /* Quantity stepper */
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var next = (parseInt(qtyInput.value, 10) || 1) + step;
        qtyInput.value = next < 1 ? 1 : next;
      });
    });

    /* Sticky "Buy Now": submits the real buy-box form (so the chosen colour
       and quantity are honoured) with return_to, which sends the shopper
       straight from /cart/add to checkout - no cart page in between. */
    var stickyBtn = document.querySelector('[data-sticky-atc]');
    if (stickyBtn && form) {
      var clearReturnTo = function () {
        var old = form.querySelector('input[name="return_to"]');
        if (old) old.parentNode.removeChild(old);
      };

      stickyBtn.addEventListener('click', function () {
        // Selected colour sold out: take the shopper to the picker instead of an error page.
        if (submit && submit.disabled) {
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        clearReturnTo();
        var rt = document.createElement('input');
        rt.type = 'hidden';
        rt.name = 'return_to';
        rt.value = stickyBtn.getAttribute('data-return-to') || '/checkout';
        form.appendChild(rt);
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });

      // Back-button restores from bfcache would otherwise leave return_to in
      // the form and hijack the main Add to Cart button.
      window.addEventListener('pageshow', clearReturnTo);
    }

    // Initialise from the currently checked swatch.
    var initial = root.querySelector('[data-option-value][aria-checked="true"]');
    if (initial) select(initial.getAttribute('data-option-value'), true);
  }

  /* ---------------- Sticky ATC visibility ---------------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-bar]');
    if (!bar) return;

    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!anchor) return;

    // Position-based rather than IntersectionObserver-based: an instant jump
    // (anchor link, or loading straight onto a #hash) can skip the intersecting
    // state entirely, and IO only reports state *changes* - so the bar would
    // never appear. Reading the rect on scroll always reflects reality.
    var ticking = false;

    function update() {
      ticking = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      if (past === bar.classList.contains('is-on')) return;
      bar.classList.toggle('is-on', past);
      document.documentElement.style.setProperty(
        '--sticky-h',
        past ? bar.offsetHeight + 'px' : '0px'
      );
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
